import type { LDFlagSet } from 'launchdarkly-react-client-sdk';

/**
 * Parse the raw e2e override value (a JSON flag map the test harness sets on a cookie) into an LD
 * flag set to bootstrap the client with. Returns undefined for a missing or malformed value, so a
 * bad value can't crash the provider.
 */
export function parseE2EOverrides(raw: string | undefined): LDFlagSet | undefined {
  if (!raw) return undefined;
  try {
    const parsed: unknown = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed as LDFlagSet;
    return undefined;
  } catch {
    return undefined;
  }
}
